import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Toast from "../../utils/toast";
import { Button, TextField } from "@mui/material";
import { Alert } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  resetPassword,
  setError,
  updateTPPassword,
} from "../../Redux/slices/authSlice";

const RedAlert = styled(Alert)(({ theme }) => ({
  "& .MuiAlert-message": {
    color: "red",
    fontWeight: "bold",
  },
}));

const UpdatePassword = () => {
  const dispatch = useDispatch();
  const { loading, error, userType } = useSelector((state) => state.auth);

  const newPasswordRef = useRef(null);
  const confirmPasswordRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { email, otp, role } = location.state || {
    email: "",
    otp: "",
    role: "",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submitting");
    // Clear any previous errors
    dispatch(setError(null));

    const newPassword = newPasswordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    if (newPassword !== confirmPassword) {
      dispatch(setError("Passwords do not match!"));
      return;
    }

    try {
      const userRole =
        role || userType || window.sessionStorage.getItem("role");

      let action;
      if (userRole === "TP-Interviewer") {
        action = updateTPPassword({ email, otp, newPassword, confirmPassword });
      } else {
        action = resetPassword({
          email,
          otp,
          newPassword,
          confirmPassword,
          role: userRole,
        });
      }

      await dispatch(action).unwrap();

      // Clear the password fields after successful submission
      if (newPasswordRef.current) newPasswordRef.current.value = "";
      if (confirmPasswordRef.current) confirmPasswordRef.current.value = "";

      navigate("/success", {
        state: {
          source: "updated-password",
        },
      });

      Toast.success("Password updated successfully");
    } catch (error) {
      // Error handling is done in the reducer
      // Clear the password fields after submission attempt
      if (newPasswordRef.current) newPasswordRef.current.value = "";
      if (confirmPasswordRef.current) confirmPasswordRef.current.value = "";
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4">
      <h2 className="gradient-text">Update Password</h2>
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-4">
        {error && (
          <RedAlert severity="error" style={{ marginBottom: "10px" }}>
            {error}
          </RedAlert>
        )}

        <div className="input-group-password">
          <TextField
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="New Password*"
            inputRef={newPasswordRef}
            className="custom-textfield-password"
            required
            fullWidth
            variant="outlined"
            size="small"
            sx={{ backgroundColor: "#006A71" }}
          />
          <span
            className="input-group-text-password"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <i className="bi bi-eye eye"></i>
            ) : (
              <i className="bi bi-eye-slash eye"></i>
            )}
          </span>
        </div>

        <div className="input-group-password">
          <TextField
            type={showPassword ? "text" : "password"}
            name="confirmPassword"
            placeholder="Confirm Password*"
            inputRef={confirmPasswordRef}
            className="custom-textfield-password"
            required
            fullWidth
            variant="outlined"
            size="small"
            sx={{ backgroundColor: "#006A71" }}
          />
          <span
            className="input-group-text-password"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <i className="bi bi-eye eye"></i>
            ) : (
              <i className="bi bi-eye-slash eye"></i>
            )}
          </span>
        </div>

        <Button type="submit" className="gradient-button" disabled={loading}>
          {loading ? <Loader /> : "Submit"}
        </Button>
      </form>
    </div>
  );
};

export default UpdatePassword;
